import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { AppComponent } from './app/app.component';
import { rootRouterConfig } from './app/app.routing';
import { environment } from './environments/environment';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxSpinnerModule } from 'ngx-spinner';
import { LightboxModule } from 'ngx-lightbox/lightbox.module';
import { BnNgIdleService } from 'bn-ng-idle';
import { RecaptchaModule, RecaptchaFormsModule, RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { provideNativeDateAdapter, MAT_DATE_LOCALE, MatRippleModule } from '@angular/material/core';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { OverlayModule } from '@angular/cdk/overlay';
import { A11yModule } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TabRouteReuseStrategy } from './app/services/core/utils/tab-route-reuse.strategy';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeEs);

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      NgxSpinnerModule,
      LightboxModule,
      RecaptchaModule,
      RecaptchaFormsModule,
      RecaptchaV3Module,
      MatRippleModule,
      OverlayModule,
      A11yModule,
      ScrollingModule,
    ),
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
    provideRouter(rootRouterConfig),
    TabRouteReuseStrategy,
    { provide: RouteReuseStrategy, useExisting: TabRouteReuseStrategy },
    provideAnimations(),
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    // Registrar interceptor funcional usando la API de interceptores funcionales
    provideHttpClient(withInterceptors([authInterceptor])),
    BnNgIdleService,
  ],
}).catch((err) => console.error(err));
